<template>
    <Button
        size="Extra-Extra-Small"
        variant="Neutral-Light"
        :icon-description="iconDescription"
        :status="status"
        @click="copyToClipBoard"
    >
        <template #icon>
            <ContentCopyIcon class="size-3" />
        </template>
    </Button>
</template>

<script setup lang="ts">
import { $t } from '@/plugins/fluent';
import { computed, provide, ref } from 'vue';
import { ButtonStatus } from '../Button/Button.types';
import Button from '../Button/Button.vue';
import ContentCopyIcon from '../Icon/ContentCopyIcon.vue';
import { triggerHideTooltipKey } from '../Tooltip/injectionKeys';

type CopyTextButtonProps = {
    text: string;
};

const props = defineProps<CopyTextButtonProps>();

const status = ref<ButtonStatus>('Default');

// This is used to force close the Tooltip after clicking the button
const triggerHideTooltipKeyCounter = ref(0);
provide(triggerHideTooltipKey, triggerHideTooltipKeyCounter);

function triggerHideTooltip() {
    triggerHideTooltipKeyCounter.value = triggerHideTooltipKeyCounter.value + 1;
}

function copyToClipBoard() {
    navigator.clipboard
        .writeText(props.text)
        .then(
            () => {
                // Successfully copied
                status.value = 'Success';
            },
            () => {
                status.value = 'Error';
                throw new Error(`Copying ${props.text} to clipboard failed`);
            },
        )
        .finally(() => {
            triggerHideTooltip();
        });
}

const iconDescription = computed(() => {
    switch (status.value) {
        case 'Default':
            return $t('copy-text-button-copy-to-clipboard');
        case 'Success':
            return $t('copy-text-button-copy-to-clipboard-success');
        case 'Error':
            return $t('copy-text-button-copy-to-clipboard-error');
    }
});
</script>
